import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useQueryClient, useMutation } from 'react-query'
import styled from 'styled-components'
import colors from '../../configuration/colors'
import { hideModal } from '../../actions/modal'
import withApiData from '../HOC/withApiData'
import Modal from '../mini/Modal'
import LoadingSpinner from '../mini/LoadingSpinner'
import FlexAlignCenter from '../presentational/FlexAlignCenter'
import Button from '../mini/Buttons/Button'
import H3 from '../typography/headers/H3'
import { publishJourney } from '../mycourses/API'
import P2 from '../typography/paragraphs/P2'

const ModalContainer = styled.div`
  width: 519px;
  height: 235px;
  border-radius: 8px;
  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);
  background: ${colors.white};
  margin: 180px auto;
  overflow: hidden;
`

const MainContainer = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  background-color: ${colors.white};
  border: none;
  margin: 0 auto;
  padding: 0;
  text-align: center;
`

const DescriptionText = styled.h3`
  width: 419px;
  margin: 0 auto;
  padding: 30px 0;
  color: #000000;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
`

const ButtonBlock = styled.div`
  border-top: 1px solid #eeeeee;
`

const PublishJourneyModal = ({ apiData, activityCourseId, journeyId }) => {
  const dispatch = useDispatch()
  const orgId = useSelector(state => state.organization.orgId)
  const userId = useSelector(state => state.user.user.id)
  const queryClient = useQueryClient()

  const [isPublishKickedOff, setIsPublishKickedOff] = useState(false)
  const publishJourneyMutation = useMutation(
    ({ apiData, activityCourseId, journeyId }) =>
      publishJourney(apiData, activityCourseId, journeyId)
  )

  const onPublishJourneyClick = () => {
    publishJourneyMutation.mutate(
      {
        apiData,
        activityCourseId,
        journeyId
      },
      {
        onSuccess: () => {
          setIsPublishKickedOff(true)
        }
      }
    )
  }

  const closeTheModal = () => {
    setTimeout(() => {
      dispatch(hideModal())
    }, 300)
  }

  useEffect(() => {
    const publishChannel = window.oeQwPusherInstance.subscribe(
      `questmaker.organizations.${orgId}.users`
    )

    publishChannel.bind('mentor_custom_course_publishing_completed', data => {
      if (data.user_ids.includes(userId)) {
        queryClient.setQueryData(
          ['activity-course-journey-' + journeyId],
          a => ({
            ...a,
            ...{
              marked_ready_for_enrollment_at:
                data.course.marked_ready_for_enrollment_at
            }
          })
        )

        setTimeout(() => {
          dispatch(hideModal())
        }, 300)
      }
    })

    return () => {
      publishChannel.unbind('mentor_custom_course_publishing_completed')
    }
  }, [])

  return (
    <Modal
      width={1400}
      percentHeight={100}
      background={'rgba(36,54,70,0.48)'}
      lockBodyScroll={false}
      opacity={'.9'}
      allowInnerScroll
      allowCloseOnExternalClick={false}
    >
      <ModalContainer>
        {!isPublishKickedOff ? (
          <div>
            <MainContainer>
              <DescriptionText>Are you ready to publish this journey?</DescriptionText>
            </MainContainer>
            <P2 style={{ textAlign: 'center', padding: '0 20px 20px' }}>
              Once published, the journey structure will be locked and you will
              no longer be able to add or remove levels or activities.
            </P2>
            <ButtonBlock>
              <FlexAlignCenter
                style={{
                  justifyContent: 'flex-end',
                  padding: '18px 15px 23px 0'
                }}
              >
                <Button
                  buttonColor={colors.white}
                  width="95px"
                  borderColor={colors.aluminum}
                  title="Cancel"
                  hoverBackground={colors.charcoal4}
                  hoverColor={colors.white}
                  handleClick={closeTheModal}
                />
                <div style={{ width: '17px' }}>&nbsp;</div>
                <Button
                  width="157x"
                  title="Publish Journey"
                  buttonColor={colors.oeYellow}
                  borderColor={colors.oeYellow}
                  hoverBackground={colors.charcoal4}
                  hoverColor={colors.white}
                  handleClick={onPublishJourneyClick}
                />
              </FlexAlignCenter>
            </ButtonBlock>
          </div>
        ) : (
          <FlexAlignCenter
            style={{
              height: '100%',
              justifyContent: 'center',
              padding: '0 130px'
            }}
          >
            <LoadingSpinner />
            <H3 style={{ marginLeft: '15px' }}>Publishing journey...</H3>
          </FlexAlignCenter>
        )}
      </ModalContainer>
    </Modal>
  )
}

PublishJourneyModal.propTypes = {
  apiData: PropTypes.object.isRequired,
  activityCourseId: PropTypes.number.isRequired,
  journeyId: PropTypes.number.isRequired
}

export default withApiData(PublishJourneyModal)



// WEBPACK FOOTER //
// ./src/components/modal/PublishJourneyModal.js